import CategoryForm from "../../../../component/CategoryForm/CategoryForm";
import { useEffect, useState} from "react";
import Loading from "../../../../component/Loading/Loading";

const BrandForm = ({brand, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setIsLoading(false);
        })();

    }, []);


    if (isLoading)
        return <Loading/>

    return (
        <CategoryForm category={brand.category} onChange={(value) => {
            const newCategory = {...value};
            onChange({...brand , category : newCategory});
        }} />
    );
}

export default BrandForm;